import { isUndefined } from 'lodash';
import React from 'react';

import Link from '@swf/components/Link/Link';
import Translation from '@swf/components/Translation/Translation';
import { RoutingKey } from '@swf/core/enums';

import type { Article, ArticlesList, Category } from '../../types';
import { getCategoryTitle } from '../../utils';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import SideBar from '../SideBar/SideBar';

import {
  TXTWCL_OopsX_Page_not_found,
  TXTWCL_Related_Articles
} from './ArticleDetail.messages.json';
import styles from './ArticleDetail.scss';
import Feedback from './components/Feedback/Feedback';

interface Props {
  categories: Category[];
  articleDetail: ArticlesList | undefined;
  relatedArticles: Article[];
}

const ArticleDetail: React.FC<Props> = ({ categories, articleDetail, relatedArticles = [] }) => {
  const { title = '', content = '', category = '' } = articleDetail?.[0] || {};
  const categoryId = category.substring(category.indexOf('-') + 1);
  const categoryTitle = getCategoryTitle(categories, categoryId);

  const sideNavs = relatedArticles.map(({ id, title, ref }) => ({
    id,
    element: (
      <Link route={RoutingKey.HelpCenterArticle} values={{ ref }}>
        {title}
      </Link>
    )
  }));

  return (
    <section>
      <div className={styles.inner}>
        {category && <Breadcrumb id={categoryId} title={categoryTitle} />}
        <div className={styles.content}>
          <div className={styles.article}>
            <h1 className={styles.title}>{title}</h1>
            {title ? (
              <>
                <div dangerouslySetInnerHTML={{ __html: content }} className={styles.articleBody} />
                <Feedback article={articleDetail?.[0]} />
              </>
            ) : (
              !isUndefined(articleDetail) && (
                <div className={styles.center}>
                  <Translation tagName="h2" {...TXTWCL_OopsX_Page_not_found} />
                </div>
              )
            )}
          </div>
          {!!sideNavs.length && (
            <SideBar sideNavs={sideNavs} title={<Translation {...TXTWCL_Related_Articles} />} />
          )}
        </div>
      </div>
    </section>
  );
};

export default ArticleDetail;
